const SubAbas = [
  { label: 'Meus Dados', rota: '/secsaude/meusdados/usuario' },
  { label: 'Meus Acessos', rota: '/secsaude/meusdados/acessos' },
  { label: 'Meus Logs', rota: '/secsaude/meusdados/logs' },
  /*{ label: 'Relatórios Gerados', rota: '/daf/meusdados/relatorios' },*/
];

export default SubAbas;
